const actionTypes = {
  SET_SOUND: 'SET_SOUND',
  SET_MUSIC: 'SET_MUSIC',
  SET_THEME: 'SET_THEME',
}

const setSound = value => async dispatch => dispatch({ type: actionTypes.SET_SOUND, payload: value });

const setMusic = value => async dispatch => dispatch({ type: actionTypes.SET_MUSIC, payload: value });

const setTheme = value => async dispatch => dispatch({ type: actionTypes.SET_THEME, payload: value });

export {
  actionTypes,
  setSound,
  setMusic,
  setTheme,
}